import { mergeWithArrayOverride } from '@yimoka/shared';
import rawZhCN from 'antd/locale/zh_CN';

import { normalizeAntdLocale } from './normalize.js';

const zhCN = normalizeAntdLocale(rawZhCN);

export default mergeWithArrayOverride({}, zhCN, {
  Common: { confirm: '确定', cancel: '取消', submit: '提交', reset: '重置' },
  Exception: {
    backHome: '返回首页',
    retry: '再试一次',
    errorTitle: '出错了',
    forbidden: '抱歉，你无权访问该页面',
    notFound: '抱歉，你访问的页面不存在',
    serverError: '抱歉，服务器出错了',
  },
  ListFilter: { query: '查询', reset: '重置' },
  RecordDel: { popconfirmTitle: '确定删除吗？', popconfirmDescription: '删除后无法恢复', text: '删除' },
  RecordEnable: { popconfirmTitle: '确定启用吗？', text: '启用' },
  RecordDisable: { popconfirmTitle: '确定禁用吗？', text: '禁用' },
  RecordBatchDel: { popconfirmTitle: '确定批量删除吗？', popconfirmDescription: '删除后无法恢复', text: '批量删除' },
  RecordBatchEnable: { popconfirmTitle: '确定批量启用吗？', text: '批量启用' },
  RecordBatchDisable: { popconfirmTitle: '确定批量禁用吗？', text: '批量禁用' },
  StoreTable: { total: total => `总共 ${total} 条记录`, itemsPerPage: '条/页' },
  UploadS3: { upload: '上传' },
  YimokaImage: { empty: '暂无图片' },
  InImage: {
    delete: '删除',
    inputAddress: '输入地址',
    viewAddress: '查看地址',
    inputTitle: '输入图片地址',
    inputPlaceholder: '请输入图片地址',
    viewTitle: '查看图片地址',
  },
  PrefixPhoneSelect: { placeholder: '请输入', countryNameField: 'chinese_name' },
  I18nEditor: {
    confirm: '确定',
    title: '多语言',
    help: '如果内容为空，则采用默认字段内容；确定内容后，请记得提交保存。',
    addLanguage: '添加语言',
    selectLanguage: '请选择语言',
    languageExists: '该语言已存在',
  },
});
